import React, { useEffect, useState } from 'react'
import { Navigate, useLocation, useParams } from "react-router-dom"
import { fetchCurrentUser, getUsername, isAssociateManagerOrAbove, isSenior, canViewMaintenanceDashboard, isICCSupport, canViewManagerDashboard, useAuth} from './components/auth';
import { Unauthorized } from './components/common/Unauthorized';
import { isAssociate, userIsSafetyTeam } from "./components/auth/Auth";

export const ProtectedRoute = ({ children }) => {
    const auth = useAuth();
    const location = useLocation();
    const [restoring, setRestoring] = useState(true);

    useEffect(() => {
        let cancelled = false;
        fetchCurrentUser()
            .then(userData => {
                if (cancelled) return;
                if (userData) {
                    auth.saveUser(userData);
                } else {
                    auth.clearUser();
                }
            })
            .catch(error => {
                console.error("Failed to restore session:", error);
                if (!cancelled) {
                    auth.clearUser();
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setRestoring(false);
                }
            });

        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (restoring) {
        return null;
    }

    if (sessionStorage.getItem("user") == null) {
        return <Navigate to="/login" state={{ redirectLocation: location }} replace />
    }
    return children

};

export const AuthorizedRoute = (props) => {
    const { id } = useParams()

    const viewingConditions = {
        'homepage': true,
        'members': isSenior() || isAssociateManagerOrAbove() || (props.route === 'members' && id === getUsername()),
        'teams': isSenior() || isAssociateManagerOrAbove() || userIsSafetyTeam(),
        'assets': isAssociate() || isSenior() || isAssociateManagerOrAbove() || canViewMaintenanceDashboard() || userIsSafetyTeam(),
        'devicesubtypes': isICCSupport() || isAssociateManagerOrAbove(),
        'readiness': isAssociate() || isSenior() || isAssociateManagerOrAbove(),
        'readinessReport': isAssociateManagerOrAbove(),
        'onestop': isAssociate() || isSenior(),
        // associates should be able to view their own, so we do another
        // check in the event detail page
        'events': true,
        'teamcalendar': true,
        'profile': true,
        'standdown': true,
        'forms': true,
        'documents': true,
        'maintenance': canViewMaintenanceDashboard(),
        'roadblock_report': isICCSupport() || isAssociateManagerOrAbove(),
        'future_readiness': isICCSupport() || isAssociateManagerOrAbove() || isSenior(),
        'support': isICCSupport() || isAssociateManagerOrAbove(),
        'manager_dashboard': canViewManagerDashboard()
    }

    const viewingConditionSatisfied = viewingConditions[props.route]
    if (!viewingConditionSatisfied) {
        return <Unauthorized />
    }

    return props.children
}
